



































































































import BaseComponent from '@/components/base-component.vue';
import PrescriptionTemplateParameter from '@/components/prescription-templates/form/parameter-template.vue';
import PrescriptionTemplateForm from '@/components/prescription-templates/prescription-template-form.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { convertCharacters } from '@/helpers/convertCharacters';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import PrescriptionTemplateModel from '@/models/prescription-template-model';
import * as service from '@/services/prescription-templates';
import { PATIENT_TYPES } from '@/settings/consts/patient';
import { PATTERN, PROFILE } from '@/settings/consts/template-types';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    PrescriptionTemplateForm,
    UiToggleStatus,
    UiAutocompleClientsSubsidiaries,
    PrescriptionTemplateParameter,
  },
})
export default class PrescriptionTemplates extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;
  public patientTypesCombo: any = [];

  public filter: any = {
    term: '',
    client: null,
    tipoPaciente: null,
    listaIndexacao: [],
  };

  public headers: any = [
    { text: 'Código', value: 'codigo' },
    { text: 'Nome', value: 'nome' },
    { text: 'Paciente', value: 'tipoPaciente' },
    { text: 'Produtos', value: 'produtos', sortable: false },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];
  public patientTypes: any = {};
  public templateTypes: any = {};
  public data: PrescriptionTemplateModel[] = [];
  public item: PrescriptionTemplateModel = new PrescriptionTemplateModel();

  public onChangeFilter(): void {
    this.load();
  }

  public beforeMount(): void {
    this.load();
    this.getPatientTypes();
    this.getTemplateTypes();
  }

  @Watch('item.padroesTemplate')
  public onListaIndexacaoChange(val: any) {
    this.filter.listaIndexacao = val;
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = convertCharacters(
      this.filter.term.toString(),
    ).toLowerCase();
    const clientUnitId = !!this.filter.clientUnit
      ? this.filter.clientUnit.id
      : null;

    const tipoPaciente = !!this.filter.tipoPaciente
      ? this.filter.tipoPaciente
      : null;

    return items.filter((row) => {
      let index1Found = true;
      let index2Found = true;
      let index3Found = true;
      let index4Found = true;

      this.filter.listaIndexacao.map((item) => {
        if (item.tipoParametro == 'INDEXACAO_1') {
          index1Found = !!row.valoresPadroesTemplate.find(
            (padrao) => padrao.id === item.id,
          );
        }
        if (item.tipoParametro == 'INDEXACAO_2') {
          index2Found = !!row.valoresPadroesTemplate.find(
            (padrao) => padrao.id === item.id,
          );
        }
        if (item.tipoParametro == 'INDEXACAO_3') {
          index3Found = !!row.valoresPadroesTemplate.find(
            (padrao) => padrao.id === item.id,
          );
        }
        if (item.tipoParametro == 'INDEXACAO_4') {
          index4Found = !!row.valoresPadroesTemplate.find(
            (padrao) => padrao.id === item.id,
          );
        }
      });

      let clientUnitFound;
      if (!!clientUnitId) {
        clientUnitFound = !!row.unidadesCliente.find(
          (unidade) => unidade.id === clientUnitId,
        );
      }

      let tipoPacienteFound;
      if (!!tipoPaciente)
        tipoPacienteFound = row.tipoPaciente.id === tipoPaciente;
      else tipoPacienteFound = true;

      const findByName = (item) => {
        return (
          !!item.nome &&
          filter(convertCharacters(item.nome.toLowerCase()), searchLower)
        );
      };

      const findByCode = (item) => {
        return (
          !!item.codigo &&
          filter(convertCharacters(item.codigo.toLowerCase()), searchLower)
        );
      };

      return (
        (findByName(row) || findByCode(row)) &&
        (!clientUnitId || clientUnitFound) &&
        tipoPacienteFound &&
        index1Found &&
        index2Found &&
        index3Found &&
        index4Found
      );
    });
  }

  public onEditItem(item: PrescriptionTemplateModel): void {
    this.loader.start('Carregando item...');
    service.getPrescriptionTemplate(item.id).subscribe(
      (data) => {
        this.item = data;
        this.formOpen = true;
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      },
    );
  }

  public saveItem(item: PrescriptionTemplateModel): void {
    this.closeForm();
    this.load();
  }

  public toggleItemStatus(
    item: PrescriptionTemplateModel,
    status: boolean,
  ): void {
    this.loader.start('Atualizando registro...');
    service.activateTemplate(Number(item.id), status).subscribe(
      (data) => {
        item.ativo = data.ativo;
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao atualizar o Template', 'error');
      },
    );
  }

  public newItem(): void {
    this.item = new PrescriptionTemplateModel();
    this.formOpen = true;
  }

  public closeForm(): void {
    this.item = new PrescriptionTemplateModel();
    this.formOpen = false;
    resetModalScroll('.input-section form');
  }

  private getTemplateTypes(): void {
    this.templateTypes = {
      [PROFILE]: 'Perfil',
      [PATTERN]: 'Padrão',
    };
  }

  private getPatientTypes(): void {
    this.patientTypes = PATIENT_TYPES;
    this.getPatientTypesCombo();
  }

  private load(): void {
    this.data = [];
    this.loading = true;
    service.getPrescriptionTemplates().subscribe(
      (res) => {
        this.data = res;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  private getPatientTypesCombo(): void {
    this.patientTypesCombo = Object.keys(PATIENT_TYPES).map((type) => {
      return {
        value: type,
        label: PATIENT_TYPES[type],
      };
    });
    this.patientTypesCombo.push({
      value: null,
      label: 'Todos',
    });
  }
}
